"use client";
import React from "react";
import { FaFilePrescription } from "react-icons/fa";
import Table from "../../../components/Table";
import PaymentField from "../../../components/PaymentField";
import overlayStyles from "../../../css/components/overlaymodal-animations.module.css";
import styles from "../css/ClaimStatus.module.css";

// Overlay modal that shows Claim Status
export default function ClaimStatus({
  isOpen = true,
  onClose,
  scriptData,
  claimDetails: passedClaimDetails,
}) {
  if (isOpen === false) return null;
  const { drugs } = scriptData || {};

  const columns = [
    { header: "Drug Name", accessor: "drugName" },
    { header: "Pack Size", accessor: "packSize" },
    { header: "ICD-10", accessor: "icd10" },
    { header: "Strength", accessor: "strength" },
    { header: "Qty", accessor: "quantity" },
    { header: "Cost Price", accessor: "costPrice" },
    { header: "Status", accessor: "status" },
  ];

  const data =
    drugs?.map((drug) => ({
      drugName: drug.drugName,
      packSize: drug.packSize || "N/A",
      icd10: drug.icd10 || "N/A",
      strength: drug.strength || "N/A",
      quantity: drug.quantity || "N/A",
      costPrice: drug.costPrice || "N/A",
      status: drug.status || "N/A",
    })) || [];

  const finalClaimDetails = passedClaimDetails || {
    title: "Claim Status",
    claimId: "CLM_2025-001637",
    submitted: "2025/07/11 11:19:39",
    priceTitle: "Price",
    price: "R213.98",
    pricePlaceholder: "R0.00",
    feeTitle: "Professional Fee",
    fee: "R37.67",
    feePlaceholder: "R0.00",
    coPayTitle: "Co-Payment",
    coPay: "R14.06",
    coPayPlaceholder: "R0.00",
    grossTitle: "Gross",
    gross: "R251.50",
    grossPlaceholder: "R0.00",
  };

  // demo values
  const scriptNumber = "01163782";
  const totalItems = 4;
  const pharmacist = "N Khan";
  const paymentTypeValue = "Medical Aid";
  const practitionerValue = "M Moodley - 689523";

  // progress percent (fallback to 70%)
  const progressPercent = Number(passedClaimDetails?.progressPercent ?? 70);

  return (
    <div className={`${overlayStyles.modalOverlay} ${overlayStyles.show}`}>
      <div className={`${overlayStyles.modalContent} ${styles.modalContent}`}>
        <div className={styles.scrollArea}>
        {/* Top compact info fields */}
        <div className={styles.header}>
          <div>
            <label>Script Number</label>
            <input type="text" defaultValue={scriptNumber} readOnly />
          </div>
          <div>
            <label>Total Items</label>
            <span>{totalItems}</span>
          </div>
          <div>
            <label>Pharmacist</label>
            <span>{pharmacist}</span>
          </div>
          <div>
            <label>Payment Type</label>
            <select defaultValue={paymentTypeValue} disabled>
              <option>{paymentTypeValue}</option>
            </select>
          </div>
          <div>
            <label>Practitioner</label>
            <input type="text" defaultValue={practitionerValue} readOnly />
          </div>
        </div>
        {/* Main lavender card */}
        <div className={styles.scriptStatus}>
          <div className={styles.titleRow}>
            <h3>
              <FaFilePrescription className={styles.icon} /> Claim Status
            </h3>
            <span className={styles.statusPill}>Processing</span>
          </div>
          <div className={styles.fields}>
            <div>
              <label>Claim ID</label>
              <input type="text" value={finalClaimDetails.claimId} readOnly />
            </div>
            <div>
              <label>Submitted</label>
              <input type="text" value={finalClaimDetails.submitted} readOnly />
            </div>
          </div>
          <div className={styles.pricePanel}>
            <PaymentField details={finalClaimDetails} />
          </div>
          <div className={styles.progressRow}>
            <div className={styles.progressLabel}>Processing Progress</div>
            <div className={styles.progressLabel}>{progressPercent}%</div>
          </div>
          <div className={styles.progressWrapper}>
            <div className={styles.progressBar}>
              <div className={styles.progressFill} style={{ width: `${progressPercent}%` }}></div>
            </div>
          </div>
          <div className={`${styles.tableWrapper} ${styles.tableCard}`}>
            <Table columns={columns} data={data} />
          </div>
        </div>
        </div>
      </div>
    </div>
  );
}
